import { Container, Logo, Wrapper } from '@/components/loaders/OverlaidLogoLoader/styled';

const OverlaidLogoLoader = () => {
  return (
    <Container>
      <Wrapper>
        <Logo />
      </Wrapper>
    </Container>
  );
};

export default OverlaidLogoLoader;
